<template lang="pug">
panel-base(
  :title="title"
  :value="inputValue"
  v-bind="$attrs"
  v-on="actionEvents"
)
  app-text-input(
    append-icon="$izoom"
    :label="title"
    :value="inputValue"
    clearable
    @input="onUpdateSearchInput"
  )

  template(v-if="isLoading")
    template(v-for="i in constants.ITEM_SKELETON_COUNT")
      v-skeleton-loader(
        type="list-item"
      )

  template(v-else)
    app-list.list
      template(v-if="!!addresses.length")
        app-list-item-group(
          v-model="selectedAddress"
        )
          template(v-for="address in addresses")
            app-list-item(
              :value="address"
              :input-value="inputValue === address"
            )
              v-list-item-content {{ address }}
      template(v-else)
        app-list-item
          | Не найдено
    //- app-button(
    //-   rounded
    //-   :disabled="isSelectButtonDisabled"
    //-   @click="selectItem"
    //- ).mt-2 Выбрать
</template>

<script>
import debounce from 'lodash/debounce';
import PanelBase from './PanelBase.vue';
import { ROW_ACTION_KEY, LIST_SKELETON_COUNT } from '../constants';
import { PER_PAGE } from '@/constants/pagination';

const DEBOUNCE_DELAY = 300;

export default {
  name: 'PanelAddress',
  components: {
    PanelBase,
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    value: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      addresses: [],
      isLoading: false,
      selectedAddress: this.value,
    };
  },
  computed: {
    constants() {
      return {
        LIST_SKELETON_COUNT,
      };
    },
    inputValue: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
    actionEvents() {
      const { reset } = ROW_ACTION_KEY;
      const resetAction = `click:${reset}`;

      return {
        [resetAction]: () => {
          this.selectedAddress = null;
          this.inputValue = null;
          this.$emit(resetAction);
        },
        ...this.$listeners,
      };
    },
    isSelectButtonDisabled() {
      return !this.selectedAddress || this.inputValue === this.selectedAddress;
    },
  },
  watch: {
    selectedAddress() {
      if (!this.isSelectButtonDisabled) this.selectItem();
    },
  },
  created() {
    this.debouncedGetAddresses = debounce(this.getAddresses, DEBOUNCE_DELAY);
  },
  methods: {
    getAddresses(query) {
      this.isLoading = true;

      this.$models.dadata
        .suggestAddresses({
          data: {
            query,
            count: PER_PAGE.twenty,
          },
        })
        .then(({ items }) => {
          this.addresses = items.map(({ address }) => address);
        })
        .catch(() => {
          this.$toast.error('Произошла ошибка при попытке получить данные');
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    onUpdateSearchInput(value) {
      this.debouncedGetAddresses(value);
    },
    selectItem() {
      this.inputValue = this.selectedAddress;
      this.$emit('click:select');
    },
  },
};
</script>
